<title>{{ gettingStartedPage.htmlTitle }}</title>
<app-section [gettingStartedPage]="true" [sections]="gettingStartedPage.sections"></app-section>
